export default __webpack_public_path__ + "static/media/home-icon-active.25ad2ae2.webp";